var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _circle, _circle2, _circle3, _circle4, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCatalogHeroIllustration = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 512.2,
  height: 364.998,
  viewBox: "0 0 1025.41 728.998"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#090814",
  d: "m645.741 25.031-27.9 7.697s-12.69 1.305-1.923 37.52 18.61 105.786 54.779 112.176c36.169 6.389 64.997-75.618 64.997-75.618z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#513333",
  d: "m522.778 294.938 108.955-19.476-5.616 37.257-99.374 8.225c-3.882 5.455-10.482 9.581-18.417 10.791-13.884 2.117-26.559-5.481-28.31-16.971-1.753-11.49 8.082-22.52 21.966-24.638 7.935-1.21 15.464.763 20.796 4.812"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D4AF37",
  d: "M679.218 162.161H668.36l-6.515 10.325-55.767 109.328 25.61 37.25 36.672-37.356z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M679.218 162.161H668.36l-6.515 10.325-55.767 109.328 25.61 37.25 36.672-37.356z",
  opacity: 0.2
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#513333",
  d: "M730.06 43.491c-13.084-28.469-46.77-40.94-75.24-27.855-28.468 13.085-40.94 46.77-27.855 75.24 10.612 23.088 34.774 35.651 58.713 32.597l8.998 13.704-27.502 106.065 58.738-58.492 31.344-65.683s-17.4-8.935-30.53-21.992c9.668-15.624 11.583-35.638 3.335-53.584"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#d6d6e3",
  d: "m899.628 260.434 8.686 213.896H719.391V258.32zM148.767 333.321h26.903V725.33h-26.903zM261.271 333.321h26.903V725.33h-26.903zM579.216 333.321h26.903V725.33h-26.903z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#090814",
  d: "m686.699 368.974-179.67 50.74s-55.478 11.602-25.886 78.777 32.401 157.436 32.401 157.436l29.316 1.086s31.05-99.286-5.429-179.695c0 0 179.469 2.435 203.564-15.752s30.809-40.865 10.332-75.995c-20.476-35.13-64.628-16.597-64.628-16.597"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#090814",
  d: "m744.364 132.313-61.89 95.005 9.773-81.976-28.23 66.775 42.33 167.75 43.445-5.428z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#D4AF37",
  d: "M764.45 415.698 688.77 251.542l59.395-123.572 24.959 12.695s38.45 12.773 20.1 61.137c-18.349 48.364-8.84 119.256 5.972 130.279 14.81 11.023 38.545 46.158 38.545 46.158s-5.45 31.79-73.29 37.46"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#D4AF37",
  d: "m713.42 383.125-51.575 1.086 17.373-66.822-26.059-35.24s-23.248-25.202-9.464-51.827l13.807-25.805 14.064-42.109 21.767-20.323-17.373 85.233z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#090814",
  d: "m769.853 366.528-179.668 50.74s-55.479 11.603-25.887 78.777S596.7 653.481 596.7 653.481l29.316 1.086s31.05-99.286-5.429-179.694c0 0 179.468 2.434 203.564-15.753s30.809-40.865 10.332-75.995c-20.476-35.13-64.629-16.597-64.629-16.597M490.725 308.166l156.501 2.213 6.515 8.686-311.166.373z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#d6d6e3",
  d: "M691.719 336.838h26.903v381.165h-26.903z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#d6d6e3",
  d: "M148.767 345.549h550.29v19.566h-550.29zM661.845 467.272s-25.707 37.12 80.347 39.63 167.751-10.857 167.751-10.857 16.862-16.46-1.629-27.226c-18.49-10.766-48.968-18.671-91.204-8.604s-155.265 7.057-155.265 7.057"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#d6d6e3",
  d: "M738.188 499.63v11.714l24.09-.098s9.34 8.336 34.202 8.143c24.863-.193 23.344-7.058 23.344-7.058l53.758-.987v-16.928z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#d6d6e3",
  d: "M780.2 504.058v194.896h35.281V503.376z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#d6d6e3",
  d: "M686.818 690.734V703.7h209.01v-14.115z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 855.583,
  cy: 712.42,
  r: 9.783,
  fill: "#d6d6e3"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 894.715,
  cy: 712.42,
  r: 9.783,
  fill: "#d6d6e3"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 689.274,
  cy: 712.42,
  r: 9.783,
  fill: "#d6d6e3"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 728.405,
  cy: 712.42,
  r: 9.783,
  fill: "#d6d6e3"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#d6d6e3",
  d: "M97.407 318.646h657.902v26.903H97.407z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#570808",
  d: "M343.18 320.445a7.52 7.52 0 0 1-7.124-5.11l-38.243-112.766c-.782-2.308-.424-4.773.982-6.762s3.61-3.15 6.046-3.183l148.68-2.002h.003c3.188 0 6.01 1.936 7.122 4.816l43.138 111.767a7.44 7.44 0 0 1-.774 6.908 7.44 7.44 0 0 1-6.102 3.329z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#513333",
  d: "m578.46 309.591 108.955-19.476-5.616 37.258-99.374 8.224c-3.882 5.455-10.482 9.582-18.417 10.791-13.884 2.117-26.559-5.481-28.31-16.971-1.753-11.49 8.082-22.52 21.966-24.638 7.934-1.21 15.464.763 20.796 4.812"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#D4AF37",
  d: "m770.514 219.933-56.278 102.063-32.794 3.429-15.483-31.788 22.761-18.486 39.905-102.903"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#090814",
  d: "m595.462 626.71.28 45.721-23.262 38.798s-23.75 1.427-21.052 14.684l60.495-.252 16.714-26.346-.837 26.348 17.298-1.079.716-44.202s-4.052-18.571-14.64-19.925l-9.858-38.742z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#090814",
  d: "m510.474 626.71.28 45.721-23.262 38.798s-23.75 1.427-21.052 14.684l60.495-.252 16.714-26.346-.837 26.348 17.298-1.079.716-44.202s-4.052-18.571-14.64-19.925l-9.858-38.742z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M1019.818 728.998H5.514c-3.287-.145-5.715-1.794-5.502-3.69-.213-1.877 2.215-3.525 5.502-3.67h1014.302c2.896.205 5.181 1.526 5.537 3.195.464 2.041-1.999 3.895-5.537 4.165"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#090814",
  d: "M617.842 32.728s62.602-89.208 137.575 26.937c0 0 34.926 10.644 62.534 47.141s9.573 147.354-44.255 155.855c0 0 22.942-94.688-7.858-113.524s-77.45-74.406-77.45-74.406l-.797.327-60.129-27.9zM382.26 92.017c-5.676 9.727-30.91 35.24-40.259 41.41-35.762 23.599-24.023-10.54-35.658-28.182-1.172-1.777-4.969-5.643-7.477-5.176-5.598 1.04-59.345 65.423-79.37 81.67-1.75 1.42-6.626.51-7.476 2.875 8.647 31.342 24.852 75.211 32.208 104.675.678 2.718-.634 10.497 1.15 16.104l36.234 1.725c10.622 22.62-7.553 16.82-30.483 17.254-20.689.393-41.572-1.331-62.114-1.15-4.288-24.03 10.174-14.008 41.41-17.83l-34.509-127.68c14.872-12.08 80.286-74.273 86.27-82.82 1.393-1.988.845-6.272 2.877-8.627 19.564 12.516 1.93.423.575-2.875-.179-.435-.604-9.218 3.45-4.602-10.301-39.659 40.018-7.38 64.991-14.378 35.05 9.382 39.951 7.441 28.182 27.607"
})));
export { SvgCatalogHeroIllustration as ReactComponent };
export default __webpack_public_path__ + "b2fa62a1251f70a188f2d099d4ac2b85.svg";